import templateUrl from '../report-repository.html';
import head from 'lodash/head';

export const reportRepositoryMainComponent = {
	templateUrl,

	//binding title, details and onSubmit function
	bindings: {
		programYears: '<',
		serviceAreaList: '<',
		pageTitle: '@',
		isShortDetails: '@',
		details: '<',
		onSubmit: '&',
		onCancel: '&',
		disableButtons: '<'
	},
	controller: class ReportRepositoryMainComponent {
		constructor(toastr, $parse, ReportRepositoryService) {
			'ngInject';

			this.toastr = toastr;
			this.$parse = $parse;
			this.reportRepositoryService = ReportRepositoryService;
		}

		$onInit() {
			this.isPdfRequired = this.details && this.details.uuid ? false : true;
			this._isShortDetails = this.$parse(this.isShortDetails || 'false')(false);
			this.fileName = this.details && this.details.name ? this.details.name : 'BROWSE';
		}

		onFileChange(file) {
			this.disableButtons = true;
			if (file && (file.type === "application/pdf")) {
				this.reportRepositoryService.uploadPdf(file)
					.then((details) => {
						this.details.uuid = details.uuid;
						this.fileName = file.name;
						this.disableButtons = false;
					})
					.catch((err) => {
						this.toastr.error(err);
						this.disableButtons = false;
					});
			} else {
				this.toastr.error("Invalid pdf file");
				this.disableButtons = false;
			}
		}

		onDelete() {
			this.isPdfRequired = true;
			this.fileName = 'BROWSE';
			this.file = "";
		}

		onChangeProgramYear(id) {
			this.details.selectedProgramYearId = id;
		}

		onChangeCounty(id) {
			this.details.selectedServiceAreaId = id;
		}
	}
}


// WEBPACK FOOTER //
// ./src/app/common/components/report-repository/report-repository-main/report-repository-main.component.js